export default __webpack_public_path__ + "static/media/css-grid.d6019588.jpg";